import './SignUp.css';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { UserContext } from "../../context/UserContext";
import ErrorMessage from "../../common/ErrorMessage/ErrorMessage";
import CountrySelect from './countries';
import { Snackbar } from '@mui/material';
import {BASE_URL} from "../../baseUrl"


function SignUp() {


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  /***********************************************************************/
  /*Code for backend*/
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password,setPassword]= useState("");
  const [confirmationPassword, setConfirmationPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("")
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");

  //const userContextArray = useContext(UserContext);
  //const setToken = userContextArray[1];
  const [login, setLogin] = useContext(UserContext);

  // State for Snackbar visibility and message
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  // Function to close Snackbar
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  /*The next line would not work in js unless you define the const differet: 
  const userContextArray = useContext(UserContext);
  const setToken = userContextArray[1];
    const [,setToken] = useContext(UserContext);
  */

  const submitRegistration = async () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ Email: email, Category:5, Account:"DB205000TX2023",Name: name, City: city, Country: country, ID_Client:1, Bio:"", hashed_pass: password, ID_Corp:0, Email_conf:0}),
    };

    try {
      const response = await fetch(BASE_URL+"/api/users", requestOptions);
      const data = await response.json();

      if (!response.ok) {
          // Handle server-side errors
          console.log("Error Response:", data);
          return { status: 'error', message: data.detail || 'An error occurred during registration.' };
      } else {
          // Handle successful registration
          console.log("Success Response:", data);
          // Optionally, you can adjust here if you need to return some success data
          return { status: 'success', data: data };
      }
    } catch (error) {
      // Handle network errors or errors in the fetch operation itself
      console.error("Fetch Error:", error);
      return { status: 'error', message: 'Network error or problem reaching the server.' };
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password === confirmationPassword && password.length > 5 && name !== " " && password !== " " && confirmationPassword !== " ") {
      const result = await submitRegistration();

      if (result.status === 'error') {
        // Display the error message from the API
        //setErrorMessage(result.message);
        setSnackbarMessage(result.message);
        setSnackbarOpen(true);
      } else {
        handleSubmitClick();
      }
      
    } else {
      setErrorMessage("Ensure that the name field is complete, passwords match and are greater than 5 characters");
    }
  };
  /***********************************************************************/
  
  const [formStepsNum, setFormStepsNum] = useState(0);
  const [passwordMatch, setPasswordMatch] = useState(true);
  const progressRef = useRef(null);
  const handleSelectionCountry = (selectedvalue) => {
    setCountry(selectedvalue);
  };

  const updateProgressbar = () => {
    if (progressRef.current) {
      const progressSteps = progressRef.current.querySelectorAll(".progress2-step");

      progressSteps.forEach((progressStep, idx) => {
        if (idx <= formStepsNum) {
          progressStep.classList.add("progress2-step-check");
          progressStep.classList.add("progress2-step-active");

        } else {
          progressStep.classList.remove("progress2-step-check");
          progressStep.classList.remove("progress2-step-active");
          
        }
      });

      const progressActive = progressRef.current.querySelectorAll(".progress2-step-active");
      const progress = progressRef.current.querySelector("#progress2");

      progress.style.width =
        ((progressActive.length - 1) / (progressSteps.length - 1)) * 100 + "%";
    }
  };

  useEffect(() => {
    updateProgressbar();
  }, [formStepsNum]);

  const handleNextClick = () => {
    if (formStepsNum === 0 && !passwordMatch) {
        // Show warning if passwords do not match
        alert("Passwords do not match!");
        return;
      }
    
    setFormStepsNum((prevNum) => prevNum + 1);
    updateProgressbar();
  };

  const handlePrevClick = () => {
    if (formStepsNum > 0) {
        setFormStepsNum((prevNum) => prevNum - 1);
        updateProgressbar();
      }
  };

  const handleSubmitClick = () => {
    const progressSteps = document.querySelectorAll(".progress2-step");
  
    progressSteps.forEach((progressStep, idx) => {
      if (idx <= formStepsNum) {
        progressStep.classList.add("progress2-step-check");
      } else {
        progressStep.classList.remove("progress2-step-check");
      }
    });
  
    const forms = document.getElementById("forms");
    forms.classList.remove("formSU");
    forms.innerHTML = `
    <div class="welcome">
      <div class="content">
        <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
          <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
        </svg>
        <h2>Thank you for signing up!</h2>
        <h2 style="color: red;">Check your email and activate your account</h2>
        <a href="https://dashboard.planningcommitment.org" class="btnLIN" style="fontcolor: white" >Go back to Dashboard Page to login</a>
      </div>
    </div>
  `;
  };
  

  return (
    
          <div>
              <form
                    action="#"
                    className="formSU"
                    id="forms"
                    onSubmit={(event) => event.preventDefault()}>

                <div className='group-inputs'></div>
                <p className='parag'> Follow the prompts to create an account </p>
            
                <div className="progress2bar ">

                  <div className="progress2" style={{ width: `${(formStepsNum / 2.3) * 100}%` }}></div>

                  {/*     divide formStepsNum /2 if you want to add the steps 2&3     */}
        
                  <div className={`progress2-step ${formStepsNum > 0 ? "progress2-step-active progress2-step-check" : ""}`} data-title="Account"></div>
                  <div className={`progress2-step ${formStepsNum > 1 ? "progress2-step-active progress2-step-check" : ""}`} data-title="Create Password"></div>
                  <div className={`progress2-step ${formStepsNum > 2 ? "progress2-step-active progress2-step-check" : ""}`} data-title="Location"></div>
          
                </div>

                {formStepsNum === 0 && (
                        <div className="step-forms step-forms-active">
                          <div className="group-inputs">
                            <label htmlFor="position">Name</label>
                            <input 
                                  type="text"
                                  placeholder="Enter your full name"
                                  value={name}
                                  onChange={(e)=>setName(e.target.value)} 
                                  name="position" id="position"
                                  required />
                          </div>

                          <div className="group-inputs">
                            <label htmlFor="position">Email</label>
                            <input 
                                  type="text"
                                  placeholder="Enter email"
                                  value={email}
                                  onChange={(e)=>setEmail(e.target.value)} 
                                  name="position" 
                                  id="position" 
                                  required/>
                          </div>

                          <div>
                              
                              <button
                                className={`btnSU btn-next width-50 ml-auto' ${name === '' || email === '' ? "btn-disabled" : ""}`}
                                onClick={handleNextClick}
                                disabled={name === '' || email === ''}
                              >
                            Next
                              </button>
                          </div>
                        </div>
                      )}

                      {formStepsNum === 1 && (
                        <div className="step-forms step-forms-active">
                          <div className="group-inputs">
                            <label htmlFor="password">Password</label>
                            <input
                                  type="password"
                                  name="password"
                                  placeholder="Enter password"
                                  id="password"
                                  value={password}
                                  onChange={(e) => setPassword(e.target.value)}
                                  required
                            />
                          </div>

                          <div className="group-inputs">
                            <label htmlFor="confirmPassword">Confirm password</label>
                            <input
                                  type="password"
                                  name="confirmPassword"
                                  placeholder="Confirm password"
                                  id="confirmPassword"
                                  value={confirmationPassword}
                                  onChange={(e) => {
                                    setConfirmationPassword(e.target.value);
                                    setPasswordMatch(e.target.value === password && e.target.value !== '' && password !== '');
                                  }}
                                  required
                                />
                          </div>

                          <div className="btns-group">
                            <button className="btnSU" onClick={handlePrevClick}>
                            Previous
                            </button>
                            <button
                              className={`btnSU btn-next ${(!passwordMatch || password === '' || confirmationPassword === '') ? "btn-disabled" : ""}`}
                              onClick={handleNextClick}
                              disabled={!passwordMatch || password === '' || confirmationPassword === ''}
                            >
                            Next
                            </button>
                          </div>
                        </div>
                      )}


                {formStepsNum === 2 && (
                      <div className="step-forms step-forms-active">
                        <div className="group-inputs">
                          <label htmlFor="position">City</label>
                          <input 
                                type="text" 
                                name="city"
                                placeholder="Austin" 
                                id="city"
                                value={city}
                                onChange={(e) => setCity(e.target.value)} 
                          />
                        </div>

                        <div className="group-inputs">
                          {/*<label htmlFor="position">Country</label>*/}

                          <div>
                             <CountrySelect onSelectionChange={handleSelectionCountry} />
                          </div>
                        </div>

                        <ErrorMessage message={errorMessage} />
                        <Snackbar
                          open={snackbarOpen}
                          autoHideDuration={6000} // Auto close after 6 seconds
                          onClose={handleCloseSnackbar}
                          message={snackbarMessage}
                        />
                        <br />
                        
                        <div className="btns-group">
                          <button className="btnSU" onClick={handlePrevClick}>
                          Previous
                          </button>
                          <button className="btnSU" onClick={handleSubmit}>
                          Submit
                          </button>
                        </div>
                      </div>
                )}

              </form> 
            </div>
  );
}

export default SignUp;


